import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli (Pirn) KV2002 machine

export default function LengthRow() {
   return (
      <InputRangeRow
         titleProp={"Length"}
         descriptionProp={"m"}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={999999}
         propertyNameProp={"length"}
         errorDialogueProp={"0-999,999 only"}
         floatProp={false}
      />
   );
}
